import { render, staticRenderFns } from "./ChatbotHelp.vue?vue&type=template&id=9f4558b2"
import script from "./ChatbotHelp.vue?vue&type=script&lang=js"
export * from "./ChatbotHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports